import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

export default class extends Controller {
  connect() {
    new Swiper(this.element.querySelector('.swiper'), {
      modules: [Navigation, Pagination, Autoplay],
      spaceBetween: 0,
      slidesPerView: 1,
      navigation: {
        nextEl: this.element.querySelector('.swiper-button-next-custom'),
        prevEl: this.element.querySelector('.swiper-button-prev-custom'),
      },
      pagination: {
        el: this.element.querySelector('.swiper-pagination-custom'),
        clickable: true,
      },
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
      speed: 800,
      loop: true,
    });
  }
}
